import React, { useState, useContext, createRef, useEffect } from 'react';
import { Header, Container, Grid, Divider, Segment, GridColumn, Modal, Input } from 'semantic-ui-react';
import { Button, Icon, Image, Label, Card, List } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';
import { AppState } from '../../context';
import { Loader, Dimmer } from 'semantic-ui-react';
import Avatar from 'react-avatar';
import { dbFamMember, dbCaregivers, dbTasks } from '../../firebase';
import firebase from 'firebase/app';
import 'firebase/functions';
import Senior from '../ProfileCreation/Senior';

const SecondaryProfile = ({active}) => {
  const someContext = useContext(AppState);
  // const [ModalOpen, setModalOpen] = useState(false);
  const [ModalOpensettings, setModalOpensettings] = useState(false);
  const {
    user,
    setUser,
    logged, 
    setLogged,
    familyMembers,
    caregivers,
    tasks,
    name,
    setName,
    seniors
  } = someContext;
  const withMenu = (page) => {
    return (
      <Container>
        {/* <TopMenu /> */}
        {page}
      </Container>
    )
  };


  const[firstName, setFirstName]=useState("");
  const[lastName, setLastName]=useState("");
  const[type,setType]=useState("");
  const[famID,setFamID]=useState("") // primary family member id
  const[totalcaregivers,setCaregiverss]=useState([]); // all the caregivers
  const[otherFamMembers,setOtherFamMembers]=useState([]); //ALL fam members beside the secondary one.


  const params = useParams();
  const uidString = params["userid"];
  const idList = familyMembers ? familyMembers[uidString]["seniors"] : ""

  useEffect(()=>{
    const  initialzeName = (snappy3) =>{
      setFamID(snappy3.val().familyMembers);
      console.log(snappy3.val().familyMembers);
      setFirstName(snappy3.val().firstName);
      console.log("man")
      setLastName(snappy3.val().firstName);
      setType(snappy3.val().type);
    
    }
    dbFamMember.child(uidString).on('value',initialzeName,error=>alert(error));
    return ()=>{dbFamMember.child(uidString).off('value',initialzeName)}
  }, []);

  useEffect(()=>{
    const  initialzeName = (snappy3) =>{
    if(snappy3.val()[famID]){
      setCaregiverss(snappy3.val()[famID]["caregivers"]);
      console.log("go")
      var temp=snappy3.val()[famID]['secondaryFam'];
      var tempactual=temp.filter((input)=> input!==uidString)
      tempactual.push(famID) // otherFam includes the primary family member.
      setOtherFamMembers(tempactual);
    }
  }
    dbFamMember.on('value',initialzeName,error=>alert(error));
    return ()=>{dbFamMember.off('value',initialzeName)}
  }, [famID]);



  const SettingsModal = () => {
    return (
      <Modal open={ModalOpensettings} basic size='small' centered={true} >
        <div style={{ textAlign: "center" }}>
          <Modal.Actions >
            <Button.Group vertical style={{ width: "200px" }}>
              <div style={{ width: "40px", marginLeft: "205px", marginBottom: "5px" }}>
                <Button basic icon="close" color="white" inverted onClick={() => setModalOpensettings(false)} />
              </div>
              <Button basic color='green'>Edit Profile</Button>
              {/* <Button basic color='green'>Edit Senior Profile</Button> */}
              {/* <Button basic color='green' as={Link} to={`/familymembers/manageview/${uidString}`}>Manage View Access</Button> */}
              {/* <Button basic color='green' as={Link} to={`/familymembers/add/caregiver/${uidString}/1`}>Add Cargeivers</Button> */}
              <Button basic color='green'>Contact Us</Button>
              <Button inverted color='red' as={Link} to={'../login'} onClick={() => setLogged(false)}>Logout</Button>
            </Button.Group>
          </Modal.Actions>
        </div>
      </Modal>
    );
  };

  const [loader, setLoader] = useState(true);
  setTimeout(() => { setLoader(false) }, 500)

  // function SeniorInfo(idd) {
  //   return (
  //     seniors ?
  //       <Segment raised>
  //         <Card.Header style={{ marginBottom: "7px" }}>
  //           <strong style={{ fontSize: "medium" }}>{"Name: "}</strong>
  //           {seniors[idd]["firstName"] + " " + seniors[idd]["lastName"]}
  //         </Card.Header>
  //         {seniors[idd]["birthdate"] ?
  //           <Card.Header style={{ marginBottom: "4px" }}>
  //             <strong style={{ fontSize: "medium" }}>{"Age: "}</strong>
  //             {seniors[idd]["birthdate"]}
  //           </Card.Header> : ""}
  //         <Card.Meta style={{ marginBottom: "5px", marginTop: "7px" }}> <strong style={{ fontSize: "medium" }}>Health Issues: </strong></Card.Meta>
  //         <Card.Description>
  //           {Object.keys(seniors[idd]["HealthIssues"]).length ? Object.keys(seniors[idd]["HealthIssues"]).map(function (input) {
  //             return (<Label color="blue" style={{ marginBottom: "4px" }}>{input}</Label>)
  //           }) : <Label color="blue"> {Object.keys(seniors[idd]["HealthIssues"])}</Label>}
  //           <Button style={{ padding: "10px", marginLeft: "5px" }} compact size="mini" circular><Icon fitted name="plus" /></Button>
  //         </Card.Description>
  //         <Card.Meta style={{ marginBottom: "5px", marginTop: "7px" }}> <strong style={{ fontSize: "medium" }}>Current Medications: </strong></Card.Meta>
  //         <Card.Description>
  //           {Object.keys(seniors[idd]["Medications"]).length ? Object.keys(seniors[idd]["Medications"]).map(function (input) {
  //             return (<Label color="blue" style={{ marginBottom: "4px" }}>{input}</Label>)
  //           }) : <Label color="blue"> {Object.keys(seniors[idd]["Medications"])}</Label>}
  //           <Button style={{ padding: "10px", marginLeft: "5px" }} compact size="mini" circular><Icon fitted name="plus" /></Button>
  //         </Card.Description>
  //       </Segment>
  //       : ""
  //   )
  // }

  function Loaded() {
      console.log("loaded")
    function Care({ input }) {
      return (
        <List.Item style={{ marginLeft: "30px" }}>
          <List.Content>
            <List.Header>{caregivers && caregivers[input] ? caregivers[input]["firstName"] : ""}</List.Header>
            <div style={{ fontWeight: "normal", color: "grey", fontSize: "11px" }}>
              {caregivers[input] && caregivers[input]["tasks"] ? Object.values(caregivers[input]["tasks"]).length + " tasks pending" : "0 tasks pending"}
            </div>
          </List.Content>
        </List.Item>)
    }
    function SecFam({ input }) {
      return (
        <List.Item style={{ marginLeft: "30px" }}>
          <List.Content>
            <List.Header>{familyMembers && familyMembers[input] ? familyMembers[input]["firstName"] : ""}</List.Header>
            <div style={{ fontWeight: "normal", color: "grey", fontSize: "11px" }}>Emergency contact</div>
          </List.Content>
        </List.Item>)
    }
    function Seniorr({ input }) {
      return (
        <List.Item style={{ marginLeft: "30px" }}>
          <List.Content>
            <List.Header>{seniors[input] ? seniors[input]["firstName"] : ""}</List.Header>
            {seniors[input] && seniors[input]["HealthIssues"] && Object.keys(seniors[input]["HealthIssues"]).length ? Object.keys(seniors[input]["HealthIssues"]).map(function (val) {
              return (<Label circular key={val} style={{ marginTop: "3px", marginRight: "5px" }} color={"black"} size={"mini"}>
                <div style={{ marginLeft: "5px", marginRight: "5px" }}>{val}</div>
              </Label>)
            }) : <Label color="black" size={"mini"}> {seniors[input] ? Object.keys(seniors[input]["HealthIssues"]) : ""}</Label>}<br />
            {seniors[input] && seniors[input]["Medications"] && Object.keys(seniors[input]["Medications"]).length ? Object.keys(seniors[input]["Medications"]).map(function (val) {
              return (<Label key={val} circular style={{ marginTop: "5px", marginRight: "5px" }} color={"grey"} size={"mini"}>
                <div style={{ marginLeft: "5px", marginRight: "5px", marginTop: "1px", marginBottom: "1px" }}>{val}</div>
              </Label>)
            }) : <Label color="grey" size={"mini"}> {seniors[input] ? Object.keys(seniors[input]["Medications"]) : ""}</Label>}
          </List.Content>
        </List.Item>)
    }
    return (
      familyMembers ? <div>
        <Container>
          <SettingsModal />
          <Grid padded>
            <Grid.Row>
              <Grid.Column width={4}>
                <Avatar style={{ marginTop: "15px" }} name={familyMembers[uidString]["firstName"] + " " + familyMembers[uidString]["lastName"]} round={true} size="70" />
              </Grid.Column>
              <Grid.Column width={12} style={{ marginTop: "25px" }}>
                <Grid.Row>
                  <Header as="h2" style={{ fontWeight: "normal", fontSize: "26px" }}>
                    {familyMembers ? familyMembers[uidString]["firstName"] + " " + familyMembers[uidString]["lastName"] + " " : ""}
                    <Button onClick={() => setModalOpensettings(true)} style={{ marginLeft: "3px", padding: "7px" }} compact size="mini" circular><Icon fitted name="setting" /></Button>
                  </Header>
                </Grid.Row>

                <Grid.Row>
                  <Header as="h5" color="grey" sub style={{ marginLeft: "2px" }}>
                    <Header.Content>
                      {"Family Member"}
                    </Header.Content >
                  </Header>
                </Grid.Row>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Header as="h4" style={{ fontWeight: "normal", fontSize: "18px", marginTop: "30px" }}>
                {familyMembers[famID]['careBool'] ? "Registered caregivers" : "No Registered caregivers" }
              </Header>
            </Grid.Row>
          </Grid>

          <List>
            {familyMembers[famID] && familyMembers[famID]['careBool']? familyMembers[famID]["caregivers"].map((input) => <Care input={input} />) : ""}
          </List>
          <Divider></Divider>
          <Grid.Row>
            <Header as="h4" style={{ fontWeight: "normal", fontSize: "18px" }}>
              {familyMembers[famID]['seniorBool'] ? "Registered seniors" : "No Registered seniors"}
            </Header>
          </Grid.Row>
          <List>
            {familyMembers[famID] && familyMembers[famID]['seniorBool']? familyMembers[famID]["seniors"].map((input) => <Seniorr input={input} />) : ""}
          </List>
          <Divider></Divider>
          <Grid.Row>
            <Header as="h4" style={{ fontWeight: "normal", fontSize: "18px" }}>
              {familyMembers[uidString] ? familyMembers[uidString]["lastName"] : ""}
              {" Family"}
            </Header>
          </Grid.Row>
          <List>
            {familyMembers[famID] && familyMembers[famID]["secondaryFam"] && familyMembers[uidString]["secondaryFam"] !== "hi" ? otherFamMembers.map((input) => <SecFam input={input} />) : ""}
          </List>


          {/*
              <Grid.Row>
                <Header as="h5" color="grey" style={{marginTop:"0px"}}>
                  <Header.Content>
                    {familyMembers ? "+1 " + familyMembers[uidString]["phone"]: ""}
                  </Header.Content >
                </Header>
              </Grid.Row>
              <Grid.Row>
                <Header as="h4" color="grey" style={{marginTop:"4px"}}>
                  <Header.Content >
                    Caregivers Registered with Homecare:
                    </Header.Content>
                </Header>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  {familyMembers[uidString]["caregivers"].map(function name(params) {
                    return (
                      <Label size="mini" color='green' horizontal>
                        {caregivers ? caregivers[params]["firstName"] : null}
                      </Label>
                    )
                  })}
                </Grid.Column>
              </Grid.Row>
              
            </Grid.Column>
          </Grid.Row >
          
          <Header style={{ marginBottom: "0px", marginTop: "5px" }} as="h4" color="grey" content="Seniors Registered with Homecare:" />
          <Grid.Row>
            <Grid.Column>
              {idList.map(id => SeniorInfo(id))}
            </Grid.Column> */}
        </Container>
      </div> :
        <Dimmer active>
          <Loader size='huge'>Loading</Loader>
        </Dimmer>
    )
  }
  if(active)
  {
    return (<div>
    {loader ?
      <Dimmer active>
        <Loader size='huge'>Loading</Loader>
      </Dimmer> : <Loaded />}
  </div>);
  }
  else{
    return null;
  }
}

export default SecondaryProfile;